import React from "react";
import { SvgIcon } from "../../../src/index";
var compPaths = {
  s: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M4.776 8.325L18.26 3.83c1.172-.391 2.288.725 1.898 1.897l-4.495 13.485c-.448 1.34-2.331 1.376-2.827.05l-2.313-5.797-5.8-2.313c-1.323-.496-1.288-2.38.053-2.827z",
    clipRule: "evenodd"
  })),
  m: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M4.776 8.325L18.26 3.83c1.172-.391 2.288.725 1.898 1.897l-4.495 13.485c-.448 1.34-2.331 1.376-2.827.05l-2.313-5.797-5.8-2.313c-1.323-.496-1.288-2.38.053-2.827z",
    clipRule: "evenodd"
  })),
  l: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M9.552 16.65L36.52 7.66c2.344-.783 4.576 1.45 3.794 3.793l-8.99 26.97c-.894 2.682-4.662 2.752-5.654.102L21.046 26.93l-11.6-4.626c-2.646-.992-2.576-4.76.106-5.654z",
    clipRule: "evenodd"
  }))
};
export var Navigation = /*#__PURE__*/React.memo(function (props) {
  return /*#__PURE__*/React.createElement(SvgIcon, Object.assign({}, props, {
    paths: compPaths,
    fill: "none"
  }));
});